<script lang="ts">
    // Mirrors RegisterPage + Petitions SignPageSkeleton: 50/50 split, hero left, form right.
</script>

<div
    class="w-full m-auto max-w-6xl py-4 px-4 md:px-8 interfont animate-pulse"
    data-testid="event-register-skeleton-loader"
>
    <div class="flex items-center gap-2 mb-4 md:mb-6">
        <div class="w-4 h-4 bg-gray-300 rounded" />
        <div class="h-4 w-28 bg-gray-300 rounded" />
    </div>

    <div class="relative flex flex-col lg:flex-row lg:min-h-0">
        <div class="hidden lg:block absolute inset-y-0 left-1/2 -translate-x-1/2 w-px bg-gray-200 pointer-events-none" />

        <!-- Left: hero + description + accordions -->
        <div class="lg:w-1/2 lg:pr-8">
            <div class="relative rounded-lg overflow-hidden bg-gray-300 h-[250px] md:h-[300px] mb-6">
                <div class="absolute bottom-0 left-0 right-0 p-6 space-y-2">
                    <div class="h-8 w-3/4 bg-gray-400/60 rounded" />
                    <div class="h-4 w-1/2 bg-gray-400/50 rounded" />
                </div>
            </div>

            <div class="space-y-3 mb-6">
                <div class="h-4 bg-gray-200 rounded w-full" />
                <div class="h-4 bg-gray-200 rounded w-5/6" />
                <div class="h-4 bg-gray-200 rounded w-4/5" />
            </div>

            <div class="space-y-3">
                {#each Array(3) as _}
                    <div class="border border-gray-200 rounded-lg px-4 py-3">
                        <div class="h-5 bg-gray-200 rounded w-2/5" />
                    </div>
                {/each}
            </div>
        </div>

        <!-- Right: registration form column -->
        <div class="lg:w-1/2 bg-white mt-8 lg:mt-0">
            <div class="p-4 lg:pl-8 lg:py-0">
                <div class="w-full max-w-[426px]">
                    <div class="h-6 w-40 bg-gray-300 rounded mb-4" />

                    <div class="space-y-5">
                        <div class="grid grid-cols-2 gap-4">
                            <div>
                                <div class="h-4 w-20 bg-gray-300 rounded mb-2" />
                                <div class="h-11 bg-gray-200 rounded-lg" />
                            </div>
                            <div>
                                <div class="h-4 w-20 bg-gray-300 rounded mb-2" />
                                <div class="h-11 bg-gray-200 rounded-lg" />
                            </div>
                        </div>

                        <div>
                            <div class="h-4 w-16 bg-gray-300 rounded mb-2" />
                            <div class="h-11 bg-gray-200 rounded-lg" />
                        </div>

                        <div>
                            <div class="h-4 w-24 bg-gray-300 rounded mb-2" />
                            <div class="h-11 bg-gray-200 rounded-lg" />
                        </div>

                        <div class="grid grid-cols-3 gap-4">
                            <div class="col-span-2">
                                <div class="h-4 w-12 bg-gray-300 rounded mb-2" />
                                <div class="h-11 bg-gray-200 rounded-lg" />
                            </div>
                            <div>
                                <div class="h-4 w-10 bg-gray-300 rounded mb-2" />
                                <div class="h-11 bg-gray-200 rounded-lg" />
                            </div>
                        </div>

                        <div class="pt-2">
                            <div class="h-12 bg-gray-300 rounded-lg w-full" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
